import React from 'react';
import '../../components/style.css';
import Image from '../../pics';

function contact() {
  return (
    <div>
        <div className="">
            <div className="">
                <h2 className="text-primary uk-text-center">
                    Contact Us
                </h2>
                <div className="uk-child-width-1-4@m uk-grid-small uk-grid-match" data-uk-grid>
                    <div>
                        <div className="uk-card">
                            <img src={Image.MAIL} alt='mail' width="50%" height="100%"/>
                            <h2>Mail</h2>
                            <p className='text-secondary'>
                                <a rel="noreferrer" className='text-secondary cont-link' href='mailto:contactus@mystratos.co.in'>
                                contactus@mystratos.co.in
                                </a>
                            </p>
                           
                        </div>
                    </div>
                    <div>
                        <div className="uk-card">
                            <img src={Image.MOBILE} alt='call' width="50%" height="100%"/>
                            <h2>Call Us</h2>
                            <p className='text-secondary'>
                           <b> TIRUPPUR : </b><a rel="noreferrer" className='text-secondary cont-link' href='tel:+917300674006'>73006 74006</a>
                            </p>
                            {/* <p className='text-secondary'>
                            <b> DELHI : </b> <a rel="noreferrer" className='text-secondary cont-link' href='tel:+917300693006'>73006 93006</a>
                            </p> */}
                        </div>
                    </div>
                    <div>
                        <div className="uk-card">

                            <img src={Image.TIME} alt='place' width="50%" height="100%"/>
                            <h2>Our Timing</h2>
                            <p className='text-secondary'>Mon - Sat : 10.00 - 05.30</p>
                            
                        </div>
                    </div>
                    <div>
                        <div className="uk-card">
                            <img src={Image.PLACE} alt='place' width="50%" height="100%"/>
                            {/* <h2>Delhi</h2>
                            <p className='text-secondary'>
                                <a rel="noreferrer" href='https://maps.app.goo.gl/2hHV2HnEB5UeQLvV7' target='_blank' className='text-secondary cont-link'>A-102, Mahipalpur, New Delhi -110037.</a>
                            </p> */}
                            <h2 className='uk-margin-small'>Tiruppur</h2>
                            <p className='text-secondary uk-margin-small'>
                            <a rel="noreferrer" href='https://maps.app.goo.gl/CeJJU32GYDZUYrzC7' target='_blank' className='text-secondary cont-link'>14A-5, Tiruppur Road, Rayarpalayam, Palladam-641664.</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    </div>
  )
}

export default contact